import type { ReportScheduleType } from '@src/models/interfaces/executionsHistoryDashboard.interface';
import {
  getRouteToCheckpointRoutesDrawer,
  getRouteToTasksTimelineDrawer,
  getRouteToTimelineEventDrawer,
} from '@src/packages/dashboard/constants';

export const getReportEventRoute = (
  scheduleType: ReportScheduleType,
  orgId: string,
  divId: string,
  triggerId: string,
  scheduleId: string,
  gte: number,
  lte: number,
  bucketStart: number,
  interval: string,
) => {
  const route =
    scheduleType === 'task'
      ? getRouteToTasksTimelineDrawer
      : scheduleType === 'checkpoint_route'
        ? getRouteToCheckpointRoutesDrawer
        : getRouteToTimelineEventDrawer;
  return route(orgId, divId, triggerId, scheduleId, gte, lte, bucketStart, interval);
};
